<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-10 mx-auto my-5">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-items-center">
          <Typography text="Editar proceso" variant="h1" class="m-0" />
          <Steps :step="step" :list="listProgress" />
        </div>

        <Typography
          text="Describa el control o las acciones a desarrollar o aplicar para gestionar el riesgo identificado."
          variant="body"
          class="m-0 pt-3 mt-3 max-w-50"
        />
        <Typography :text="title[step]" variant="h2" class="m-0 pt-3 mt-3" />
        <section :class="['mt-4', 'w-100']">
          <form onsubmit="return false" @submit="submitData">
            <div :class="['row col-12 p-0 min-h-245', step !== 0 && 'd-none']">
              <div
                class="d-flex flex-column col-4 child-flex-0 space-y-12 justify-content-around"
              >
                <Select
                  label="Tipo de control o acciones"
                  name="control_type"
                  :options="options.control_type"
                  tooltip="Tipo de control o acciones a establecer"
                  :value="formData.control_type"
                  v-model="formData.control_type"
                  :errors="computedErrors"
                  @input="validate('control_type')"
                />
                <Select
                  label="Cargo responsable"
                  name="position"
                  :options="options.positions"
                  tooltip="Cargo responsable de trabajar el control"
                  :value="formData.position"
                  v-model="formData.position"
                  :errors="errors"
                  @input="validate('position')"
                />
                <Textarea
                  label="Descripción"
                  name="description"
                  :value="formData.description"
                  tooltip="Descripción del control o acciones a tomar"
                  @input="
                    (event) => (formData.description = event.target.value)
                  "
                  :errors="errors"
                  class="mb-2"
                  rows="4"
                />
              </div>
              <div
                class="d-flex flex-column col-4 child-flex-0 space-y-12 justify-content-start"
              >
                <Input
                  type="text"
                  label="Objetivo"
                  name="objective"
                  tooltip="Qué busca hacer el control"
                  @input="(event) => (formData.objective = event.target.value)"
                  :errors="errors"
                  :value="formData.objective"
                  @keypress="validate('objective')"
                />
                <Input
                  type="text"
                  label="Procedimiento"
                  name="controlEvidence"
                  tooltip="Cómo se lleva a cabo el control"
                  @input="
                    (event) => (formData.controlEvidence = event.target.value)
                  "
                  :errors="errors"
                  :value="formData.controlEvidence"
                  @keypress="validate('controlEvidence')"
                />
                <Input
                  type="text"
                  label="Evidencia"
                  name="procedure"
                  tooltip="Evidencia de la ejecución del control"
                  @input="(event) => (formData.procedure = event.target.value)"
                  :errors="errors"
                  :value="formData.procedure"
                  @keypress="validate('procedure')"
                />
              </div>
              <div
                class="d-flex flex-column col-4 child-flex-0 space-y-12 justify-content-start"
              >
                <Select
                  label="Periodicidad"
                  name="periodicity"
                  :options="options.periodicity"
                  tooltip="Cuándo se realiza el control"
                  :value="formData.periodicity"
                  v-model="formData.periodicity"
                  :errors="errors"
                  @input="validate('periodicity')"
                />
                <Select
                  label="Evaluación efectividad"
                  name="evaluation"
                  :options="options.evaluation"
                  tooltip="Evaluación efectividad de controles"
                  :value="formData.evaluation"
                  v-model="formData.evaluation"
                  :errors="errors"
                  @input="validate('evaluation')"
                />
              </div>
            </div>
            <div :class="['row col-12 p-0 min-h-245', step !== 1 && 'd-none']">
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Select
                  label="Resultado"
                  name="result"
                  :options="options.result"
                  :value="formData.result"
                  v-model="formData.result"
                  :errors="errors"
                  @input="validate('result')"
                  required
                />
                <Select
                  label="Estado"
                  name="status"
                  :options="options.status"
                  :value="formData.status"
                  v-model="formData.status"
                  :errors="errors"
                  @input="validate('status')"
                  required
                />
                <Select
                  label="Provisión"
                  name="provision"
                  :options="options.provision"
                  :value="formData.provision"
                  v-model="formData.provision"
                  :errors="errors"
                  @input="validate('provision')"
                  required
                />
                <Select
                  label="Tipo de proceso"
                  name="type"
                  :options="options.process_types"
                  :value="formData.type"
                  v-model="formData.type"
                  :errors="errors"
                  @input="validate('type')"
                />
                <Date
                  name="dateNotification"
                  label="Fecha de notificación"
                  v-model="formData.dateNotification"
                  :value="formData.dateNotification"
                  :errors="errors"
                  @input="validate('dateNotification')"
                />
              </div>
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Select
                  label="Tutela"
                  name="guardianship_action"
                  :options="options.guardianship_action"
                  :value="formData.guardianship_action"
                  v-model="formData.guardianship_action"
                  :errors="errors"
                  @input="validate('guardianship_action')"
                  required
                />
                <Select
                  label="Querella"
                  name="complain"
                  :options="options.complain"
                  :value="formData.complain"
                  v-model="formData.complain"
                  :errors="errors"
                  @input="validate('complain')"
                  required
                />
                <Select
                  label="Pruebas a favor"
                  name="evidence"
                  :options="options.evidence"
                  :value="formData.evidence"
                  v-model="formData.evidence"
                  :errors="errors"
                  @input="validate('evidence')"
                  class="mt-5"
                  required
                />
                <Select
                  label="Prescripción"
                  name="prescription"
                  :options="options.prescription"
                  :value="formData.prescription"
                  v-model="formData.prescription"
                  :errors="errors"
                  @input="validate('prescription')"
                  required
                />
                <Input
                  type="number"
                  label="Cuantía"
                  name="amount"
                  :value="formData.amount"
                  @input="
                    (event) => (formData.amount = Number(event.target.value))
                  "
                  :errors="errors"
                  @keypress="validate('amount')"
                />
              </div>
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Select
                  label="Abogado"
                  name="lawyer"
                  :options="options.lawyers"
                  :value="formData.lawyer"
                  v-model="formData.lawyer"
                  :errors="errors"
                  @input="validate('lawyer')"
                  required
                />
                <Select
                  label="Tipo de Demandante"
                  name="worker"
                  :options="options.plaintiff_type"
                  :value="formData.worker"
                  v-model="formData.worker"
                  :errors="computedErrors"
                  @input="validate('worker')"
                />
                <Input
                  type="text"
                  label="Cedula"
                  name="cc"
                  @input="(event) => (formData.cc = event.target.value)"
                  :errors="errors"
                  @keypress="validate('cc')"
                  :value="formData.cc"
                />
                <Select
                  label="Juzgado"
                  name="court"
                  :options="options.courts"
                  :value="formData.courts"
                  v-model="formData.court"
                  :errors="errors"
                  @input="validate('court')"
                  class="mt-5"
                  required
                />
              </div>
            </div>
            <div :class="['row col-12 p-0 min-h-245', step !== 2 && 'd-none']">
              <div class="d-flex flex-column col-4 child-flex-0 space-y-12">
                <Select
                  label="Tipo de riesgo"
                  name="risk_type"
                  :options="options.risk_types"
                  :value="formData.risk_type"
                  v-model="formData.risk_type"
                  :errors="errors"
                  @input="validate('risk_type')"
                />
                <Select
                  label="Opciones de manejo Riesgo"
                  name="management_option"
                  :options="options.management_option"
                  :value="formData.management_option"
                  v-model="formData.management_option"
                  :errors="errors"
                  @input="validate('management_option')"
                />
              </div>
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Textarea
                  label="Acciones"
                  name="actions"
                  :value="formData.actions"
                  @input="(event) => (formData.actions = event.target.value)"
                  :errors="errors"
                  class="mb-2"
                  rows="4"
                />
              </div>
              <div class="d-flex flex-column col-4 space-y-12 child-flex-0">
                <Select
                  label="Seguimiento"
                  name="tracking"
                  :options="options.tracking"
                  :value="formData.tracking"
                  v-model="formData.tracking"
                  :errors="errors"
                  @input="validate('tracking')"
                />
              </div>
            </div>
            <div class="container-buttons">
              <Button
                label="Cancelar"
                showIcon
                icon="cancel"
                variant="secondary"
                colorIcon="#5D5FEF"
                @click="confirmCancel"
                v-if="step === 0"
              />
              <Button
                label="Anterior"
                showIcon
                icon="prev"
                variant="secondary"
                reverIcon
                colorIcon="#5D5FEF"
                @click="prevStep"
                v-if="step !== 0"
              />
              <Button
                label="Siguiente"
                showIcon
                icon="next"
                variant="primary"
                class="ml-4"
                @click="nextStep"
                v-if="step !== 2"
              />
              <Button
                label="Finalizar"
                type="submit"
                showIcon
                icon="check"
                variant="primary"
                class="ml-4"
                v-show="step === 2"
              />
            </div>
          </form>
        </section>
      </div>
      <!--Modal Section-->
      <div>
        <b-modal id="modal-confirm" centered hide-footer>
          <div class="text-center mb-4">
            <img
              src="@/assets/images/icons/warning_.svg"
              width="60px"
              height="60px"
              class="mx-auto"
            />
          </div>
          <Typography
            text="¿Estás seguro de cancelar esta actualización?"
            variant="h3"
            class="text-center"
          />
          <div class="row justify-content-center mt-4">
            <Button label="Si, Cancelar" variant="secondary" @click="goBack" />
            <Button
              label="Seguir Editando"
              variant="primary"
              class="ml-4"
              @click="closeModal('modal-confirm')"
            />
          </div>
        </b-modal>
        <b-modal id="modal-message" centered hide-footer>
          <div class="text-center mb-4">
            <img
              src="@/assets/images/icons/checkbox-circle-line.svg"
              width="60px"
              height="60px"
              class="mx-auto"
            />
          </div>
          <Typography
            text="¡Actualización completada!"
            variant="h2"
            class="text-center"
          />
          <Typography
            text="El proceso ha sido actualizado con exito"
            variant="body"
            class="text-center"
          />
          <div class="row justify-content-center mt-4">
            <Button label="Entendido" variant="primary" @click="goBack" />
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { useEdit } = useProcess();

export default useEdit;
</script>

<style lang="scss" scoped src="./EditProcess.scss"></style>
